<template>
  <v-card class="widget-card" style="width:100%;">
    <v-card-text class="pa-0">
      <v-container class="pa-0">
        <div class="layout row ma-0 pa-3 " :style="{ backgroundColor: color }">
          <div class="sm2 xs2 flex">
            <div class="layout column ma-0 justify-center align-center">
              <v-icon size="60px" color="white" style="opacity: 0.8;">{{icon}}</v-icon>
            </div>
          </div>
          <div class="layout dashbord column ma-0 ml-4 justify-center" style="color: white;">
            <span class="caption">{{ subTitle }}</span>
            <div class="head-line">{{ title }}</div>
            <span class="totals">{{ supTitle }} élements</span>
          </div>
        </div>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name:'WidgetComponent',
  props: {
    supTitle: {
      type: String,
      required: false
    },
    subTitle: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    color: {
      type: String,
      required: false
    }
  },

  data() {
    return {
    }
  }
}
</script>

<style>
  .widget-card {
    border-radius: 5%;
    box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.21);
    background-color: transparent;
  }

  .dashbord .head-line{
     font-size: 1.2rem!important;            
    font-weight: bold;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif !important;
  }
  .totals{
        font-size: 13px!important;
  }


</style>
